"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Timeline = void 0;
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.object.get-prototype-of.js");
var _react = _interopRequireDefault(require("react"));
var _lodash = _interopRequireDefault(require("lodash"));
var _semanticUiReact = require("semantic-ui-react");
var _utils = require("../../../common/utils");
var _constants = require("../../../common/constants");
var _FemaGoModal = _interopRequireDefault(require("./modal/FemaGoModal"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var TimelineWrapper = function TimelineWrapper(_ref) {
  var children = _ref.children,
    handleLoadMore = _ref.handleLoadMore,
    loading = _ref.loading,
    noMoreResults = _ref.noMoreResults;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "timeline"
  }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Segment, {
    basic: true
  }, /*#__PURE__*/_react.default.createElement(Line, null), children), !noMoreResults && /*#__PURE__*/_react.default.createElement(LoadMore, {
    handleClick: handleLoadMore,
    loading: loading
  }));
};
var Line = function Line() {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "timeline__line"
  });
};
var LoadMore = function LoadMore(_ref2) {
  var handleClick = _ref2.handleClick,
    loading = _ref2.loading;
  return /*#__PURE__*/_react.default.createElement(_semanticUiReact.Button, {
    primary: true,
    compact: true,
    onClick: handleClick,
    loading: loading
  }, "Load More");
};
var TimelineItem = function TimelineItem(_ref3) {
  var children = _ref3.children,
    outline = _ref3.outline;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "timeline__item"
  }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Icon, {
    name: "circle".concat(outline ? ' outline' : '')
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "timeline__item__content"
  }, children));
};
var Title = function Title(_ref4) {
  var children = _ref4.children;
  return /*#__PURE__*/_react.default.createElement("h3", null, children);
};
var DateContent = function DateContent(_ref5) {
  var children = _ref5.children;
  return /*#__PURE__*/_react.default.createElement("p", {
    className: "subheading"
  }, /*#__PURE__*/_react.default.createElement("strong", null, children), /*#__PURE__*/_react.default.createElement("br", null));
};
var UserContent = function UserContent(_ref6) {
  var label = _ref6.label,
    children = _ref6.children;
  return /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("strong", null, label), children);
};
var Timeline = /*#__PURE__*/function (_React$Component) {
  _inherits(Timeline, _React$Component);
  var _super = _createSuper(Timeline);
  function Timeline(props) {
    var _this;
    _classCallCheck(this, Timeline);
    _this = _super.call(this, props);
    _this.toggleModal = function (activeModalContent, subject) {
      _this.setState({
        modalOpen: !_this.state.modalOpen,
        body: activeModalContent !== undefined ? activeModalContent : null,
        subject: subject !== undefined ? subject : null
      });
    };
    _this.state = {
      modalOpen: false,
      confirmButton: 'hidden'
    };
    return _this;
  }
  _createClass(Timeline, [{
    key: "renderGeneric",
    value: function renderGeneric(instance, index) {
      var capitalizeFirst = function capitalizeFirst(s) {
        return !s || s.charAt(0).toUpperCase() + s.slice(1);
      };
      var entryDate = instance.entryDate,
        fullName = instance.fullName,
        payload = instance.payload;
      var dueDate = payload.dueDate,
        outcome = payload.outcome,
        processDefinitionKey = payload.processDefinitionKey,
        task = payload.task;
      var title = processDefinitionKey ? capitalizeFirst(processDefinitionKey) + ': ' + capitalizeFirst(task) : capitalizeFirst(task);
      return /*#__PURE__*/_react.default.createElement(TimelineItem, {
        outline: index === 0,
        key: index
      }, /*#__PURE__*/_react.default.createElement(Title, null, title), outcome && /*#__PURE__*/_react.default.createElement(UserContent, {
        label: "Result: "
      }, capitalizeFirst(outcome)), /*#__PURE__*/_react.default.createElement(DateContent, null, (0, _utils.secondsFromEpochToDisplayDate)(entryDate, true)), /*#__PURE__*/_react.default.createElement(UserContent, {
        label: fullName
      }), dueDate && /*#__PURE__*/_react.default.createElement(UserContent, {
        label: "Due: "
      }, (0, _utils.convertDateForDisplay)(dueDate, true)));
    }
  }, {
    key: "renderNotification",
    value: function renderNotification(instance, index) {
      var _this2 = this;
      var entryDate = instance.entryDate,
        payload = instance.payload;
      var subject = payload.subject,
        recipient = payload.recipient,
        body = payload.body;
      return /*#__PURE__*/_react.default.createElement(TimelineItem, {
        outline: index === 0,
        key: index
      }, /*#__PURE__*/_react.default.createElement(Title, null, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Icon, {
        name: "mail",
        color: "grey"
      }), /*#__PURE__*/_react.default.createElement("a", {
        href: "#",
        onClick: function onClick() {
          return _this2.toggleModal(body, subject);
        }
      }, subject)), /*#__PURE__*/_react.default.createElement(DateContent, null, (0, _utils.secondsFromEpochToDisplayDate)(entryDate, true)), /*#__PURE__*/_react.default.createElement(UserContent, {
        label: "Sent to: "
      }, recipient));
    }
  }, {
    key: "renderItem",
    value: function renderItem(instance, index) {
      switch (instance.eventType) {
        case _constants.HISTORY_TYPES.NOTIFICATION:
          return this.renderNotification(instance, index);
          break;
        default:
          return this.renderGeneric(instance, index);
          break;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props = this.props,
        timelineItems = _this$props.timelineItems,
        loading = _this$props.loading,
        noMoreResults = _this$props.noMoreResults;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(TimelineWrapper, {
        handleLoadMore: this.props.handleLoadMore,
        noMoreResults: noMoreResults,
        loading: loading
      }, _lodash.default.map(timelineItems, function (instance, index) {
        return _this3.renderItem(instance, index);
      })), /*#__PURE__*/_react.default.createElement(_FemaGoModal.default, {
        title: this.state.subject,
        open: this.state.modalOpen,
        cancelAction: this.toggleModal,
        children: this.state.body,
        displayHtml: true,
        confirmButton: this.state.confirmButton
      }));
    }
  }]);
  return Timeline;
}(_react.default.Component);
exports.Timeline = Timeline;
var _default = Timeline;
exports.default = _default;